import CloseIcon from '@mui/icons-material/Close'
import MenuIcon from '@mui/icons-material/Menu'
import {
  AppBar,
  Box,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  NativeSelect,
  Toolbar,
} from '@mui/material'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link, useLocation } from 'react-router'

import style from './style'
import { useLanguage } from '../../../LanguageContext'

const PAGES = [
  { id: 'Home', path: '/' },
  { id: 'Services', path: '/services' },
  // { id: 'WineSelection', path: '/wine-selection' },
  { id: 'Contact', path: '/contact' },
]

const Header = () => {
  const lang = useLanguage()
  const { pathname } = useLocation()
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false)

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  const toggleDrawer = () => {
    scrollToTop()
    setIsDrawerOpen(!isDrawerOpen)
  }

  const drawer = (
    <Box sx={style.drawerContainer}>
      <AppBar position="relative" sx={style.header}>
        <Toolbar sx={style.toolbar}>
          <Box component="img" src="/images/logo.png" alt="logo" width={80} />
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={toggleDrawer}
            sx={style.menuIcon}
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <List>
        <ListItem disablePadding key="language-selector" sx={style.languageSelectorContainer}>
          <NativeSelect
            value={lang}
            onChange={(e) => {
              window.location.href = pathname.replace(lang, e.target.value)
            }}
            sx={style.languageSelector}
          >
            <option value="fr">FR</option>
            <option value="en">EN</option>
          </NativeSelect>
        </ListItem>
        {PAGES.map((page) => (
          <ListItem disablePadding key={page.id}>
            <ListItemButton
              component={Link}
              to={`/${lang}${page.path}`}
              onClick={toggleDrawer}
              color="primary"
            >
              <ListItemText
                primary={<FormattedMessage id={`Header.${page.id}`} defaultMessage={page.id} />}
                sx={style.drawerItem}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  )

  const container = window.document.body

  return (
    <>
      <AppBar component="nav" sx={style.header}>
        <Toolbar sx={style.toolbar}>
          <Link to={`/${lang}/`} style={{ textDecoration: 'none' }} onClick={scrollToTop}>
            <Box component="img" src="/images/logo.png" alt="logo" width={80} />
          </Link>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={toggleDrawer}
            sx={style.menuIcon}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={style.linksContainer}>
            {PAGES.map((page) => (
              <Button
                component={Link}
                variant="text"
                key={page.id}
                to={`/${lang}${page.path}`}
                color="primary"
              >
                <FormattedMessage id={`Header.${page.id}`} defaultMessage={page.id} />
              </Button>
            ))}
          </Box>
          <NativeSelect
            value={lang}
            onChange={(e) => {
              window.location.href = pathname.replace(lang, e.target.value)
            }}
            sx={[style.languageSelector, style.desktopLanguageSelector]}
          >
            <option value="fr">FR</option>
            <option value="en">EN</option>
          </NativeSelect>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          anchor="top"
          open={isDrawerOpen}
          onClose={toggleDrawer}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={style.drawer}
        >
          {drawer}
        </Drawer>
      </nav>
    </>
  )
}

export default Header
